export default __webpack_public_path__ + "static/media/slider1.720888c5.gif";